import { useState } from 'react';
import { Card } from './Card';
import { Title } from '@portal_components/components/Title';

interface CollapsibleCardProps {
  identifier: string;
  title: string;
  children: React.ReactNode | React.ReactNode[];
  disableCollapse?: boolean;
}

export const CollapsibleCard = ({ identifier, title, children, disableCollapse }: CollapsibleCardProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <Card identifier={identifier} className="h-min p-4">
      <div
        onClick={() => !disableCollapse && setIsCollapsed(!isCollapsed)}
        className={`flex justify-between mb-2 pb-2 border-b border-b-soft-elevation-0 ${!disableCollapse ? 'cursor-pointer' : ''} relative`}
      >
        <Title className="flex flex-grow items-center justify-center text-center" text={title} />
        {!disableCollapse && <img src={`${isCollapsed ? '/arrowDown.svg' : '/arrowUp.svg'}`} alt={`${title}-arrow`} className={`m-1 h-9`} />}
      </div>
      <>{!isCollapsed && children}</>
    </Card>
  );
};
